import React from "react";

export const LeftDot = () => (
  <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 w-3 h-3 rounded-full bg-indigo-500 border-2 border-white shadow" />
);

export const RightDot = () => (
  <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 w-3 h-3 rounded-full bg-indigo-500 border-2 border-white shadow" />
);